import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import PatternQuizGame from '../PatternQuizGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day2({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage2 = themeData?.stages_data?.stage_2;
  const questions = stage2?.questions;
  const badgeUrl = s3PublicUrl(stage2?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const isConfigured =
    stage2 &&
    (stage2.type === 'pattern_logic' || stage2.type === 'qa') &&
    Array.isArray(questions) &&
    questions.length > 0;

  return (
    <DayPageShell dayNumber={2} className="main-day-view--immersive">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          Pattern stage is not configured: set stage_2 type &quot;pattern_logic&quot; and
          questions in the theme.
        </p>
      ) : (
        <PatternQuizGame
          questions={questions}
          rules={stage2.rules}
          badgeUrl={badgeUrl}
          badgeTitle={String(stage2?.title ?? stage2?.name ?? 'Day 2')}
          questionImage={String(stage2?.question_image ?? '')}
          didYouKnowImage={String(stage2?.did_you_know_image ?? '')}
          questionTextWrapClassName="day-question-panel__text-wrap--day2"
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          badgeFallbackLabel="Day 2"
          onComplete={onStageComplete}
        />
      )}
    </DayPageShell>
  );
}
